/*
 * @Description: 价目管理 新增、编辑弹出层
 * @Author: ma.cq
 * @Date: 2018-10-18 09:33:29
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-01 14:16:44
 */
<template>
  <el-dialog title="新增余额调账" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form class="form" :model="form" inline :rules="rules" ref="form" v-if="visible">
      <el-form-item label="经营组织" prop="org" label-width="125px">
        <ajax-select
        v-model="form.org"
        type="allArg"
        no-all
        clearable
        placeholder="请选择经营组织"
        valueField="obj"
        @change="handleOrgChange"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="org" label-width="125px">
      <!-- 政策部门选择客户 -->
      <tag-search-select
        v-if="form.hasPolicyPermission && form.type === 1 && form.agreementType === 0"
        v-model="form.customList"
        type="customPolicy"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChange">
      </tag-search-select>
      <!-- 非政策部门选择客户 -->
      <tag-search-select
        v-else
        v-model="form.customList"
        type="customer"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChange">
      </tag-search-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces4" label-width="125px">
        <el-select v-model="form.ces4" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调整方式" prop="ces1" label-width="125px">
        <el-radio-group v-model="form.ces1">
          <el-radio :label="2">增加</el-radio>
          <el-radio :label="1">减少</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="调整金额" prop="ces5" label-width="125px">
        <el-input-number
          controls-position="right"
          v-model="form.ces5"
          :max="9999999999"
          :min="0"
          :precision="2"></el-input-number>
      </el-form-item>
      <el-form-item label="备注" label-width="125px">
        <el-input placeholder="备注" v-model="form.ces7"></el-input>
      </el-form-item>
    </el-form>
    <!-- <div class="infoText">是否确认调整电商该该客户的账户余额？</div> -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatTime } from '../../../common/utils'
import AjaxSelect from '../../../components/ajaxSelect/index'
import TagSearchSelect from '../../../components/tagSearchSelect/index'
export default {
  name: 'addOrEditDialog',
  components: { TagSearchSelect, AjaxSelect },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      form: {
        org: '',
        pickArea: '',
        pickAreaName: '',
        deliveryArea: '',
        customList: [],
        ces7: '',
        ces1: 0,
        lockStartTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      },
      forms: {
        org: '',
        pickArea: '',
        pickAreaName: '',
        deliveryArea: '',
        customList: [],
        ces7: '',
        ces1: 0,
        lockStartTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      },
      rules: {
        org: [{ required: true, message: '请选择经营组织' }],
        customList: [{ required: true, message: '请选择客户名称' }],
        ces1: [{ required: true, message: '请选择调账方式' }],
        ces4: [{ required: true, message: '请选择币种' }],
        ces5: [{ required: true, message: '请填写金额' }],
        ces7: [{ required: true, message: '请填写备注' }]
      },
      orderType: [
        { value: 1, label: '抹零' },
        { value: 2, label: '仓储费手工开票' },
        { value: 3, label: '客户退款' },
        { value: 4, label: '客户间调账' },
        { value: 5, label: '收款冲销' }
      ],
      moneyType: [
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ]
    }
  },
  methods: {
    handleSubmit () {
      console.log(this.form)
      if (this.form.customList.length <= 0) {
        this.$message.error('请确认选择的客户')
        return
      }
      if (!this.form.ces4) {
        this.$message.error('请选择币种')
        return
      }
      if (!this.form.ces1) {
        this.$message.error('请选择调整方式')
        return
      }
      if (!this.form.ces5) {
        this.$message.error('请调整金额')
        return
      }
      this.$emit('onform', this.form)
      this.$emit('update:show', false)
      this.form = this.forms
    },
    handleOrgChange (e) {
      console.log(e)
    },
    onProtocolChange (e) {
      console.log(e)
    },
    handleCusChange (e) {
      console.log(e)
    },
    handleClose () {
      this.form = this.forms
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
    }
  }
}
</script>
<style lang="scss" scoped>
.form{
  margin: 0 auto;
  max-width: 500px;
}
.item-inline{
  display: inline-block;
}
.marLef10{
  margin-left: 10px;
}
.tip{
  color: #ccc;
  font-size: 12px;
}
.tag{
  margin: 10px 10px 0 0;
}
.timepicker{
  margin-right: 10px;
  width: 120px;
}
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.infoText {
  text-align: center;
  margin-top: 50px;
}
</style>
